import { makeStyles } from '@material-ui/core/styles';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PRIMARY_COLOR } from 'Config';
import React, { useState } from 'react';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        borderRadius: '3px',
        width: '100%',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const AEPSIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorNonSelected}
                                d="M315.8,421.3c-15.7,9.3-25.4,26.1-25.7,44.3v37.5c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5v-37.5
		c0.3-12.3,7-23.6,17.7-29.8c20.7-12.9,33.4-39.4,33.4-69s-12.8-56.1-33.4-69c-6.3-3.8-11.3-9.4-14.5-16l16.3-16.2
		c4.8-4.8,7.5-11.3,7.5-18.1c0-6.8-2.7-13.3-7.5-18.1l-19.5-19.6v-22c0-18.3-9.7-35.1-25.6-44.3c-15.8-9.1-35.3-9.1-51.1,0
		c-15.8,9.1-25.6,26-25.6,44.3v73.7l-54.7,68.4c-9,11.3-11.7,26.4-7.2,40.1l45.3,135.8v0c1.5,4.5,6.3,6.9,10.8,5.4
		c4.5-1.5,6.9-6.3,5.4-10.8l-45.3-135.7c-2.8-8.2-1.2-17.3,4.3-24.1l41.4-51.8v60.9c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V187.8
		c0-12.2,6.5-23.4,17-29.5c10.5-6.1,23.5-6.1,34.1,0c10.5,6.1,17,17.3,17,29.5v80.1c0,4.9,0.8,9.8,2.2,14.4c0.1,0.3,0.2,0.5,0.3,0.7
		h0c4.1,12.1,12.3,22.5,23.2,29.1c15.4,9.7,25.4,31.1,25.4,54.5C341.2,390.2,331.2,411.6,315.8,421.3L315.8,421.3z M314.6,241.5
		c3.3,3.3,3.3,8.7,0,12l-7.5,7.4v-27L314.6,241.5z"
                            />
                            <path
                                className={colorSelected}
                                d="M256,162.3c-6.8,0-13.3,2.7-18.1,7.5c-4.8,4.8-7.5,11.3-7.5,18.1v17c0,2.3,0.9,4.4,2.5,6
		c1.6,1.6,3.8,2.5,6,2.5H273c2.3,0,4.4-0.9,6-2.5c1.6-1.6,2.5-3.8,2.5-6v-17c0-6.8-2.7-13.3-7.5-18.1
		C269.3,165,262.8,162.3,256,162.3L256,162.3z M264.5,196.4h-17v-8.5c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5V196.4z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M375.3,119.7c0-15.7-3.1-31.3-9.1-45.9c-1.8-4.3-6.8-6.4-11.1-4.6c-4.3,1.8-6.4,6.8-4.6,11.1
		c5.2,12.5,7.9,25.8,7.8,39.3v85.2c0,26.4-10.2,51.8-28.5,70.8c-1.7,1.6-2.6,3.8-2.6,6.2c0,2.3,0.9,4.6,2.6,6.2
		c1.7,1.6,3.9,2.5,6.3,2.4c2.3-0.1,4.5-1.1,6-2.9c21.4-22.2,33.3-51.8,33.2-82.6L375.3,119.7z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M136.7,137c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-17.3c0-28.2,11.7-55.2,32.3-74.6
		c20.6-19.3,48.2-29.3,76.4-27.5c28.2,1.8,54.4,15.1,72.4,36.9c3,3.6,8.4,4.1,12,1.1c3.6-3,4.1-8.3,1.2-11.9
		c-21-25.4-51.6-41-84.4-43c-32.9-2.1-65.1,9.5-89.2,32.1c-24,22.6-37.6,54-37.6,87L136.7,137z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M136.7,204.9c-0.1,26.8,8.9,52.7,25.5,73.7c3,3.5,8.2,4.1,11.8,1.2c3.6-2.8,4.3-8,1.6-11.7
		c-14.2-18-21.9-40.3-21.8-63.2v-42.5c0-4.7-3.8-8.5-8.5-8.5s-8.5,3.8-8.5,8.5L136.7,204.9z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M323.8,212.5c-0.3,2.2,0.4,4.5,1.8,6.3c1.4,1.8,3.5,2.9,5.7,3.1c0.3,0,0.6,0,1,0c4.3,0,8-3.3,8.5-7.6
		c0.4-3.1,0.5-6.3,0.5-9.5v-85.2c0-27.6-13.4-53.6-35.9-69.5c-22.5-16-51.4-20-77.5-10.9c-4.4,1.6-6.8,6.4-5.2,10.9
		c1.6,4.4,6.4,6.8,10.9,5.2c7.3-2.6,14.9-3.9,22.6-3.8c18.1,0,35.4,7.2,48.2,20c12.8,12.8,20,30.1,20,48.2v85.2
		C324.2,207.4,324,209.9,323.8,212.5L323.8,212.5z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M199.3,56.1c-18.1,16.2-28.5,39.3-28.5,63.5v85.2c0,13.1,3,26,8.8,37.7c2.1,4.2,7.2,5.9,11.4,3.8
		c4.2-2.1,5.9-7.2,3.9-11.4c-4.7-9.4-7.1-19.7-7.1-30.2v-85.2c0-19.4,8.3-37.9,22.8-50.8c3.5-3.1,3.8-8.5,0.7-12
		C208.2,53.3,202.8,53,199.3,56.1L199.3,56.1z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M298.6,146.3c2.3,0,4.4-0.9,6-2.5c1.6-1.6,2.5-3.8,2.5-6v-18.1c0-10.7-3.4-21.2-9.7-29.9
		c-1.3-1.9-3.3-3.2-5.6-3.6c-2.3-0.4-4.6,0.1-6.4,1.5c-1.9,1.3-3.1,3.4-3.4,5.6c-0.3,2.3,0.3,4.6,1.6,6.4c4.2,5.8,6.5,12.8,6.5,19.9
		v18.1c0,2.3,0.9,4.4,2.5,6S296.3,146.3,298.6,146.3L298.6,146.3z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M204.9,119.7V137c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5v-17.3c0-9,3.6-17.7,10-24.1c6.4-6.4,15.1-10,24.1-10
		c2.3,0,4.6,0.2,6.9,0.7c4.6,0.9,9.1-2,10.1-6.6c0.9-4.6-2-9.1-6.6-10.1c-15-3.1-30.7,0.8-42.6,10.5
		C211.8,89.8,204.9,104.3,204.9,119.7L204.9,119.7z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M256,102.6c-4.7,0-8.5,3.8-8.5,8.5v8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-8.5c0-2.3-0.9-4.4-2.5-6
		C260.4,103.5,258.3,102.6,256,102.6z"
                            />
                        </g>
                    </svg>
                </p>
                <h6>{props.name}</h6>
            </div>
        </>
    );
};

export default AEPSIcon;
